import axios from "axios";
import { Base_URL } from "../url";

export const fetchDepartments = async () => {
  try {
    const response = await axios.get(`${Base_URL}/DepartmentMaster/GetAllDepartments`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching departments!";
  }
};

export const downloadDepartmentsExcel = async () => {
  try {
    const response = await axios({
      url: `${Base_URL}/DepartmentMaster/DownloadDepartmentsExcel`,
      method: 'POST',
      responseType: 'blob', 
    });
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading departments!";
  }
};